import * as React from 'react';
import { SVGProps } from 'react';

export const Sofa = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M29.1555 11.0221C28.6577 11.0221 28.1671 11.1643 27.7333 11.4203V11.0221C27.7333 8.66122 26.5387 7.46655 24.1778 7.46655H7.8222C5.46133 7.46655 4.26667 8.66122 4.26667 11.0221V11.4203C3.83287 11.1643 3.3422 11.0292 2.84447 11.0221C1.27287 11.0221 0 12.295 0 13.8666V19.5554C0 21.127 1.27287 22.3999 2.84447 22.3999H4.26667V23.8221C4.26667 24.2132 4.58667 24.5332 4.9778 24.5332C5.36893 24.5332 5.68893 24.2132 5.68893 23.8221V22.3999H26.3111V23.8221C26.3111 24.2132 26.6311 24.5332 27.0223 24.5332C27.4133 24.5332 27.7333 24.2132 27.7333 23.8221V22.3999H29.1485C30.72 22.3999 32 21.127 32 19.5554V13.8666C32 12.295 30.7271 11.0221 29.1555 11.0221ZM5.68887 11.0221C5.68887 9.45055 6.24353 8.88875 7.8222 8.88875H24.1777C25.7493 8.88875 26.3111 9.45055 26.3111 11.0221V15.9999H5.68887V11.0221ZM30.5778 19.5554C30.5778 20.3448 29.9307 20.9776 29.1485 20.9776H2.84447C2.06227 20.9776 1.42227 20.3376 1.42227 19.5554V13.8666C1.42227 13.0844 2.06227 12.4444 2.84447 12.4444C3.62667 12.4444 4.26667 13.0844 4.26667 13.8666V17.4221H27.7333V13.8666C27.7333 13.0844 28.3733 12.4444 29.1555 12.4444C29.9377 12.4444 30.5777 13.0844 30.5777 13.8666L30.5778 19.5554Z"
      fill="#071114"
    />
  </svg>
);
export default Sofa;
